import * as React from 'react';

import { useDispatch } from 'react-redux'
import { setOperation } from '../operation/operationSlice';

import DataList from '../../components/controls/datagrid/DataList';
import DataColumn from '../../components/controls/datagrid/DataColumn';

export default (props: { controller: string, items: any }) => {
    const dispatch = useDispatch()
    const onRowClick = (e: any, data: any) => {
        e.preventDefault()
        dispatch(setOperation("read", props.controller, { index: data }))
    }

    return (
        <>
            <DataList items={props.items} onRowClick={onRowClick} >
                <DataColumn kid='column1' name='Codice' fieldName='code' minWidth={120} maxWidth={120} align='left' />
                <DataColumn kid='column2' name='Nome' fieldName='name' minWidth={200} align='left' />
                <DataColumn kid='column3' name='Attivo' type="icon" fieldName='leap_RateTableStateID' minWidth={100} maxWidth={100} align='center' />
                <DataColumn kid='column4' name='Data fine validità' fieldName='endDate' minWidth={120} maxWidth={120} align='center' />
                <DataColumn kid='column5' name='Tipo Tariffario' fieldName='leap_RateTableTypeID' minWidth={120} maxWidth={120} align='left' />
                <DataColumn kid='column6' name='Tipo Gestione' fieldName='leap_RateTableManagementID' minWidth={120} maxWidth={120} align='left' />
            </DataList>
        </>
    );
}
